import { useLayoutEffect, Suspense, lazy } from 'react';
import { BrowserRouter, useLocation, Route, Routes, Navigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

/* Layouts */
import MainApp from 'layouts/MainApp';
import BoardLayout from 'layouts/BoardLayout';
import WaitLoading from 'layouts/WaitLoading';

/* Router Pages */
import PageNotFound from 'routes/404';
import ErrorPage from 'routes/error';
import Profile from 'routes/profile';
import Labatory from 'routes/labatory/index';
const Structure = lazy(() => import('routes/labatory/structure'));
const PurePropertyConstant = lazy(() => import('routes/labatory/pure-constant'));
const BinaryUNIFAC = lazy(() => import('routes/labatory/binary-unifac'));
const CosmosacML = lazy(() => import('routes/labatory/cosmosac-ml'));
import Board from 'routes/board';
import View from 'routes/board/view';
import Write from 'routes/board/write';
import Edit from 'routes/board/edit';
import Admin from 'routes/admin';
import Test from 'routes/test';

/* Global CSS */
import 'styles/global.css';
import 'styles/sun-editor.css';
import 'suneditor/dist/css/suneditor.min.css';
import 'react-toastify/dist/ReactToastify.css';

const RouteWrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location]);
  return children;
};

export default function Router() {
  return (
    <BrowserRouter>
      <RouteWrapper>
        <ErrorBoundary
          fallbackRender={() => {
            <MainApp>
              <PageNotFound />
            </MainApp>;
          }}
        >
          <Suspense
            fallback={
              <MainApp>
                <WaitLoading />
              </MainApp>
            }
          >
            <Routes>
              <Route element={<MainApp />}>
                <Route path="" element={<Profile />} />
                {/* <Route path="labatory">
                  <Route path="" element={<Labatory />} />
                  <Route path="structure" element={<Structure />} />
                  <Route path="pure-constant" element={<PurePropertyConstant />} />
                  <Route path="binary-unifac" element={<BinaryUNIFAC />} />
                  <Route path="cosmosac-ml" element={<CosmosacML />}></Route>
                </Route> */}
                {/* <Route path="board">
                  <Route element={<BoardLayout />}>
                    <Route path="" element={<Board />} />
                    <Route path=":postID" element={<View />} />
                    <Route path="write" element={<Write />} />
                    <Route path="edit/:postID" element={<Edit />} />
                  </Route>
                </Route> */}
                <Route path="404" element={<PageNotFound />} />
                <Route path="test" element={<Test />} />
                <Route path="admin" element={<Admin />} />
              </Route>
              <Route path="*" element={<Navigate to="/404" replace />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </RouteWrapper>
    </BrowserRouter>
  );
}
